import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useBreakpoint } from "gatsby-plugin-breakpoints";

import * as styles from "./ModuleWrapper.module.css";

import Accordion from "../Accordion";
import Cards from "../Cards";
import Carousel from "../Carousel";
import ContactForm from "../Forms/contact";
import CopyBlock from "../CopyBlock";
import Cta from "../CTA";
import HeadlineBanners from "../HeadlineBanners";
import Hero from "../Hero";
import ImageGrid from "../ImageGrid";
import LeadForm from "../Forms/leadForm";
import LeadMagnet from "../LeadMagnet";
import LogoRail from "../LogoRail";
import PageHeader from "../PageHeader";
import ProjectCards from "../ProjectCards";
import SplitContent from "../SplitContent";
import TextGrid from "../TextGrid";
import Tiles from "../Tiles";

import StaggeredTiles from "../StaggeredTiles";
import Billboard from "../Billboard";
import VideoPlayer from "../Video";
import MinorCTA from "../MinorCTA";
import Image from "../Image";
import LeadMagnetMini from "../LeadMagnet/leadMagnetMini";

const ModuleWrapper = ({ props, type }) => {
  const {
    size,
    isContainerFluid,
    sectionId,
    extraClasses,
    module,
    backgroundColor,
    headline,
    headlineSize,
    headlineHorizontalAlign,
  } = props;

  // const breakpoints = useBreakpoint();

  let sectionSize = size || "MD";
  if (size === "N/A") {
    sectionSize = "NA";
  }

  const container = isContainerFluid ? "container-fluid" : "container";

  // console.log("================");
  // console.log("================");
  // console.log("type", type);
  // console.log("props", props);
  // console.log("================");
  // console.log("================");

  useEffect(() => {
    // if (breakpoints.md) {
    // AOS.init();
    // }
  }, []);

  return type ? (
    <section
      className={`section ${extraClasses} section-${sectionSize} ${
        headline && "section-with-headline"
      } section-${backgroundColor}`}
      id={sectionId || null}
    >
      {headline && (
        <div
          // data-aos="zoom-in-up"
          // data-aos-duration="400"
          className={`${styles.headline} ${
            headlineSize ? styles[headlineSize] : styles.normal
          } ${
            headlineHorizontalAlign
              ? styles[headlineHorizontalAlign]
              : styles.left
          } ${backgroundColor ? styles[backgroundColor] : styles.white}`}
        >
          <h2>{headline.toUpperCase()}</h2>
        </div>
      )}
      <div className={container}>
        {type === "hero" && (
          <Hero
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "form" && module.type === "Contact" && (
          <ContactForm
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "form" && module.type === "Lead Form" && (
          <LeadForm
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "form" && module.type === "Lead Magnet Mini" && (
          <LeadMagnetMini
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "imageGrid" && (
          <ImageGrid
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "logoRail" && (
          <LogoRail
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "accordion" && (
          <Accordion
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "splitContent" && (
          <SplitContent
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
            moduleBackgroundColor={backgroundColor}
          />
        )}
        {type === "pageHeader" && (
          <PageHeader
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "cards" && (
          <Cards
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "tiles" && module?.variant === "staggered" && (
          <StaggeredTiles
            props={module}
            isContainerFluid={isContainerFluid}
            size={size}
          />
        )}
        {type === "tiles" && (
          <Tiles
            props={module}
            isContainerFluid={isContainerFluid}
            size={size}
          />
        )}
        {type === "headlineBanners" && (
          <HeadlineBanners
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "textGrid" && (
          <TextGrid
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}
        {type === "carousel" && (
          <Carousel
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
            backgroundColor={backgroundColor}
          />
        )}
        {type === "copyBlock" && (
          <CopyBlock
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
            // data-aos="fade-up"
          />
        )}
        {type === "cta" && (
          <Cta
            backgroundColor={backgroundColor}
            props={module}
            size={size}
            company={props.company}
            isContainerFluid={isContainerFluid}
          />
        )}

        {type === "leadMagnet" &&
          (module?.variant === "mini" ? (
            <LeadMagnetMini
              props={module}
              size={size}
              company={props.company}
              isContainerFluid={isContainerFluid}
            />
          ) : (
            <LeadMagnet
              props={module}
              size={size}
              company={props.company}
              isContainerFluid={isContainerFluid}
            />
          ))}

        {type === "placeholder1" && <Billboard props={module} />}
        {type === "placeholder2" && <ProjectCards props={module} />}
        {type === "placeholder10" && <VideoPlayer props={module} />}
        {type === "placeholder11" && <MinorCTA props={module} />}
        {type === "image" && <Image props={module} />}
      </div>
    </section>
  ) : (
    <></>
  );
};

export default ModuleWrapper;
